import { render, staticRenderFns } from "./RegistrarImpagoContainer.vue?vue&type=template&id=1b930209&scoped=true&"
import script from "./RegistrarImpagoContainer.vue?vue&type=script&lang=js&"
export * from "./RegistrarImpagoContainer.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarImpagoContainer.vue?vue&type=style&index=0&id=1b930209&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b930209",
  null
  
)

export default component.exports